import { call } from "redux-saga/effects";

import { createSaga } from "../../../utils/saga";
import { cloneApi } from "../client";
import slice from "../slice";
import type { ApiDto } from "../types";

interface CloneApiPayload {
  id: string;
}

function* cloneApiInternal({ id }: CloneApiPayload) {
  const result: ApiDto = yield call(cloneApi, id);
  return result;
}

export const cloneApiSaga = createSaga(cloneApiInternal, "cloneApiSaga", {
  sliceName: slice.name,
});

slice.saga(cloneApiSaga, {});
